/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */
var _a, _b;

import { ColorMap } from '../../../../mol-util/color';
export var SaccharideColors = ColorMap({
  Blue: 0x0090bc,
  Green: 0x00a651,
  Yellow: 0xffd400,
  Orange: 0xf47920,
  Pink: 0xf69ea1,
  Purple: 0xa54399,
  LightBlue: 0x8fcce9,
  Brown: 0xa17a4d,
  Red: 0xed1c24,
  Secondary: 0xf1ece1
});
var SaccharideTypeNameMap = (_a = {}, _a[0
/* Hexose */
] = 'Hexose', _a[1
/* HexNAc */
] = 'HexNAc', _a[2
/* Hexosamine */
] = 'Hexosamine', _a[3
/* Hexuronate */
] = 'Hexuronate', _a[4
/* Deoxyhexose */
] = 'Deoxyhexose', _a[5
/* DeoxyhexNAc */
] = 'DeoxyhexNAc', _a[6
/* DiDeoxyhexose */
] = 'Di-deoxyhexose', _a[7
/* Pentose */
] = 'Pentose', _a[8
/* Deoxynonulosonate */
] = 'Deoxynonulosonate', _a[9
/* DiDeoxynonulosonate */
] = 'Di-deoxynonulosonate', _a[10
/* Unknown */
] = 'Unknown', _a[11
/* Assigned */
] = 'Assigned', _a);
export function getSaccharideName(type) {
  return SaccharideTypeNameMap[type];
}
var SaccharideTypeShapeMap = (_b = {}, _b[0
/* Hexose */
] = 0
/* FilledSphere */
, _b[1
/* HexNAc */
] = 1
/* FilledCube */
, _b[2
/* Hexosamine */
] = 2
/* CrossedCube */
, _b[3
/* Hexuronate */
] = 3
/* DividedDiamond */
, _b[4
/* Deoxyhexose */
] = 4
/* FilledCone */
, _b[5
/* DeoxyhexNAc */
] = 5
/* DevidedCone */
, _b[6
/* DiDeoxyhexose */
] = 6
/* FlatBox */
, _b[7
/* Pentose */
] = 7
/* FilledStar */
, _b[8
/* Deoxynonulosonate */
] = 8
/* FilledDiamond */
, _b[9
/* DiDeoxynonulosonate */
] = 9
/* FlatDiamond */
, _b[10
/* Unknown */
] = 10
/* FlatHexagon */
, _b[11
/* Assigned */
] = 11
/* Pentagon */
, _b);
export function getSaccharideShape(type, ringMemberCount) {
  if (type === 10
  /* Unknown */
  ) {
      if (ringMemberCount === 4) return 12
      /* DiamondPrism */
      ;else if (ringMemberCount === 5) return 13
      /* PentagonalPrism */
      ;else if (ringMemberCount === 6) return 14
      /* HexagonalPrism */
      ;else if (ringMemberCount === 7) return 15
      /* HeptagonalPrism */
      ;else return 10
        /* FlatHexagon */
        ;
    } else {
    return SaccharideTypeShapeMap[type];
  }
}
export var UnknownSaccharideComponent = {
  abbr: 'Unk',
  name: 'Unknown',
  color: SaccharideColors.Secondary,
  type: 10
  /* Unknown */

};
var Monosaccharides = [{
  abbr: 'Glc',
  name: 'Glucose',
  color: SaccharideColors.Blue,
  type: 0
  /* Hexose */

}, {
  abbr: 'Man',
  name: 'Mannose',
  color: SaccharideColors.Green,
  type: 0
  /* Hexose */

}, {
  abbr: 'Gal',
  name: 'Galactose',
  color: SaccharideColors.Yellow,
  type: 0
  /* Hexose */

}, {
  abbr: 'Gul',
  name: 'Gulose',
  color: SaccharideColors.Orange,
  type: 0
  /* Hexose */

}, {
  abbr: 'Alt',
  name: 'Altrose',
  color: SaccharideColors.Pink,
  type: 0
  /* Hexose */

}, {
  abbr: 'All',
  name: 'Allose',
  color: SaccharideColors.Purple,
  type: 0
  /* Hexose */

}, {
  abbr: 'Tal',
  name: 'Talose',
  color: SaccharideColors.LightBlue,
  type: 0
  /* Hexose */

}, {
  abbr: 'Ido',
  name: 'Idose',
  color: SaccharideColors.Brown,
  type: 0
  /* Hexose */

}, {
  abbr: 'GlcNAc',
  name: 'N-Acetyl Glucosamine',
  color: SaccharideColors.Blue,
  type: 1
  /* HexNAc */

}, {
  abbr: 'ManNAc',
  name: 'N-Acetyl Mannosamine',
  color: SaccharideColors.Green,
  type: 1
  /* HexNAc */

}, {
  abbr: 'GalNAc',
  name: 'N-Acetyl Galactosamine',
  color: SaccharideColors.Yellow,
  type: 1
  /* HexNAc */

}, {
  abbr: 'GulNAc',
  name: 'N-Acetyl Gulosamine',
  color: SaccharideColors.Orange,
  type: 1
  /* HexNAc */

}, {
  abbr: 'AltNAc',
  name: 'N-Acetyl Altrosamine',
  color: SaccharideColors.Pink,
  type: 1
  /* HexNAc */

}, {
  abbr: 'AllNAc',
  name: 'N-Acetyl Allosamine',
  color: SaccharideColors.Purple,
  type: 1
  /* HexNAc */

}, {
  abbr: 'TalNAc',
  name: 'N-Acetyl Talosamine',
  color: SaccharideColors.LightBlue,
  type: 1
  /* HexNAc */

}, {
  abbr: 'IdoNAc',
  name: 'N-Acetyl Idosamine',
  color: SaccharideColors.Brown,
  type: 1
  /* HexNAc */

}, {
  abbr: 'GlcN',
  name: 'Glucosamine',
  color: SaccharideColors.Blue,
  type: 2
  /* Hexosamine */

}, {
  abbr: 'ManN',
  name: 'Mannosamine',
  color: SaccharideColors.Green,
  type: 2
  /* Hexosamine */

}, {
  abbr: 'GalN',
  name: 'Galactosamine',
  color: SaccharideColors.Yellow,
  type: 2
  /* Hexosamine */

}, {
  abbr: 'GulN',
  name: 'Gulosamine',
  color: SaccharideColors.Orange,
  type: 2
  /* Hexosamine */

}, {
  abbr: 'AltN',
  name: 'Altrosamine',
  color: SaccharideColors.Pink,
  type: 2
  /* Hexosamine */

}, {
  abbr: 'AllN',
  name: 'Allosamine',
  color: SaccharideColors.Purple,
  type: 2
  /* Hexosamine */

}, {
  abbr: 'TalN',
  name: 'Talosamine',
  color: SaccharideColors.LightBlue,
  type: 2
  /* Hexosamine */

}, {
  abbr: 'IdoN',
  name: 'Idosamine',
  color: SaccharideColors.Brown,
  type: 2
  /* Hexosamine */

}, {
  abbr: 'GlcA',
  name: 'Glucuronic Acid',
  color: SaccharideColors.Blue,
  type: 3
  /* Hexuronate */

}, {
  abbr: 'ManA',
  name: 'Mannuronic Acid',
  color: SaccharideColors.Green,
  type: 3
  /* Hexuronate */

}, {
  abbr: 'GalA',
  name: 'Galacturonic Acid',
  color: SaccharideColors.Yellow,
  type: 3
  /* Hexuronate */

}, {
  abbr: 'GulA',
  name: 'Guluronic Acid',
  color: SaccharideColors.Orange,
  type: 3
  /* Hexuronate */

}, {
  abbr: 'AltA',
  name: 'Altruronic Acid',
  color: SaccharideColors.Pink,
  type: 3
  /* Hexuronate */

}, {
  abbr: 'AllA',
  name: 'Alluronic Acid',
  color: SaccharideColors.Purple,
  type: 3
  /* Hexuronate */

}, {
  abbr: 'TalA',
  name: 'Taluronic Acid',
  color: SaccharideColors.LightBlue,
  type: 3
  /* Hexuronate */

}, {
  abbr: 'IdoA',
  name: 'Iduronic Acid',
  color: SaccharideColors.Brown,
  type: 3
  /* Hexuronate */

}, {
  abbr: 'Qui',
  name: 'Quinovose',
  color: SaccharideColors.Blue,
  type: 4
  /* Deoxyhexose */

}, {
  abbr: 'Rha',
  name: 'Rhamnose',
  color: SaccharideColors.Green,
  type: 4
  /* Deoxyhexose */

}, {
  abbr: '6dGul',
  name: '6-Deoxy Gulose',
  color: SaccharideColors.Orange,
  type: 4
  /* Deoxyhexose */

}, {
  abbr: '6dAlt',
  name: '6-Deoxy Altrose',
  color: SaccharideColors.Pink,
  type: 4
  /* Deoxyhexose */

}, {
  abbr: '6dTal',
  name: '6-Deoxy Talose',
  color: SaccharideColors.LightBlue,
  type: 4
  /* Deoxyhexose */

}, {
  abbr: 'Fuc',
  name: 'Fucose',
  color: SaccharideColors.Red,
  type: 4
  /* Deoxyhexose */

}, {
  abbr: 'QuiNAc',
  name: 'N-Acetyl Quinovosamine',
  color: SaccharideColors.Blue,
  type: 5
  /* DeoxyhexNAc */

}, {
  abbr: 'RhaNAc',
  name: 'N-Acetyl Rhamnosamine',
  color: SaccharideColors.Green,
  type: 5
  /* DeoxyhexNAc */

}, {
  abbr: '6dAltNAc',
  name: 'N-Acetyl 6-Deoxy Altrosamine',
  color: SaccharideColors.Pink,
  type: 5
  /* DeoxyhexNAc */

}, {
  abbr: '6dTalNAc',
  name: 'N-Acetyl 6-Deoxy Talosamine',
  color: SaccharideColors.LightBlue,
  type: 5
  /* DeoxyhexNAc */

}, {
  abbr: 'FucNAc',
  name: 'N-Acetyl Fucosamine',
  color: SaccharideColors.Red,
  type: 5
  /* DeoxyhexNAc */

}, {
  abbr: 'Oli',
  name: 'Olivose',
  color: SaccharideColors.Blue,
  type: 6
  /* DiDeoxyhexose */

}, {
  abbr: 'Tyv',
  name: 'Tyvelose',
  color: SaccharideColors.Green,
  type: 6
  /* DiDeoxyhexose */

}, {
  abbr: 'Abe',
  name: 'Abequose',
  color: SaccharideColors.Orange,
  type: 6
  /* DiDeoxyhexose */

}, {
  abbr: 'Par',
  name: 'Paratose',
  color: SaccharideColors.Pink,
  type: 6
  /* DiDeoxyhexose */

}, {
  abbr: 'Dig',
  name: 'Digitoxose',
  color: SaccharideColors.Purple,
  type: 6
  /* DiDeoxyhexose */

}, {
  abbr: 'Col',
  name: 'Colitose',
  color: SaccharideColors.LightBlue,
  type: 6
  /* DiDeoxyhexose */

}, {
  abbr: 'Ara',
  name: 'Arabinose',
  color: SaccharideColors.Green,
  type: 7
  /* Pentose */

}, {
  abbr: 'Lyx',
  name: 'Lyxose',
  color: SaccharideColors.Yellow,
  type: 7
  /* Pentose */

}, {
  abbr: 'Xyl',
  name: 'Xylose',
  color: SaccharideColors.Orange,
  type: 7
  /* Pentose */

}, {
  abbr: 'Rib',
  name: 'Ribose',
  color: SaccharideColors.Pink,
  type: 7
  /* Pentose */

}, {
  abbr: 'Kdn',
  name: 'Keto-Deoxy Nonulonic Acid',
  color: SaccharideColors.Green,
  type: 8
  /* Deoxynonulosonate */

}, {
  abbr: 'Neu5Ac',
  name: 'N-Acetyl Neuraminic Acid',
  color: SaccharideColors.Purple,
  type: 8
  /* Deoxynonulosonate */

}, {
  abbr: 'Neu5Gc',
  name: 'N-Glycolyl Neuraminic Acid',
  color: SaccharideColors.LightBlue,
  type: 8
  /* Deoxynonulosonate */

}, {
  abbr: 'Neu',
  name: 'Neuraminic Acid',
  color: SaccharideColors.Brown,
  type: 8
  /* Deoxynonulosonate */

}, {
  abbr: 'Sia',
  name: 'Sialic acid',
  color: SaccharideColors.Red,
  type: 8
  /* Deoxynonulosonate */

}, {
  abbr: 'Pse',
  name: 'Pseudaminic Acid',
  color: SaccharideColors.Green,
  type: 9
  /* DiDeoxynonulosonate */

}, {
  abbr: 'Leg',
  name: 'Legionaminic Acid',
  color: SaccharideColors.Yellow,
  type: 9
  /* DiDeoxynonulosonate */

}, {
  abbr: 'Aci',
  name: 'Acinetaminic Acid',
  color: SaccharideColors.Pink,
  type: 9
  /* DiDeoxynonulosonate */

}, {
  abbr: '4eLeg',
  name: '4-Epilegionaminic Acid',
  color: SaccharideColors.LightBlue,
  type: 9
  /* DiDeoxynonulosonate */

}, {
  abbr: 'Bac',
  name: 'Bacillosamine',
  color: SaccharideColors.Blue,
  type: 10
  /* Unknown */

}, {
  abbr: 'LDmanHep',
  name: 'L-Glycero-D-Manno Heptose',
  color: SaccharideColors.Green,
  type: 10
  /* Unknown */

}, {
  abbr: 'Kdo',
  name: 'Keto-Deoxy Octulonic Acid',
  color: SaccharideColors.Yellow,
  type: 10
  /* Unknown */

}, {
  abbr: 'Dha',
  name: '3-Deoxy Lyxo-Heptulosaric Acid',
  color: SaccharideColors.Orange,
  type: 10
  /* Unknown */

}, {
  abbr: 'DDmanHep',
  name: 'D-Glycero-D-Manno-Heptose',
  color: SaccharideColors.Pink,
  type: 10
  /* Unknown */

}, {
  abbr: 'MurNAc',
  name: 'N-Acetyl Muramic Acid',
  color: SaccharideColors.Purple,
  type: 10
  /* Unknown */

}, {
  abbr: 'MurNGc',
  name: 'N-Glycolyl Muramic Acid',
  color: SaccharideColors.LightBlue,
  type: 10
  /* Unknown */

}, {
  abbr: 'Mur',
  name: 'Muramic Acid',
  color: SaccharideColors.Brown,
  type: 10
  /* Unknown */

}, {
  abbr: 'Api',
  name: 'Apicose',
  color: SaccharideColors.Green,
  type: 11
  /* Assigned */

}, {
  abbr: 'Fru',
  name: 'Fructose',
  color: SaccharideColors.Green,
  type: 11
  /* Assigned */

}, {
  abbr: 'Tag',
  name: 'Tagatose',
  color: SaccharideColors.Yellow,
  type: 11
  /* Assigned */

}, {
  abbr: 'Sor',
  name: 'Sorbose',
  color: SaccharideColors.Orange,
  type: 11
  /* Assigned */

}, {
  abbr: 'Psi',
  name: 'Psicose',
  color: SaccharideColors.Pink,
  type: 11
  /* Assigned */

}];
export var SaccharidesSnfgMap = function () {
  var map = new Map();

  for (var i = 0, il = Monosaccharides.length; i < il; ++i) {
    var saccharide = Monosaccharides[i];
    map.set(saccharide.abbr, saccharide);
  }

  return map;
}();
export var MonosaccharidesColorTable = [['Glc-family', SaccharideColors.Blue], ['Man-family', SaccharideColors.Green], ['Gal-family', SaccharideColors.Yellow], ['Gul-family', SaccharideColors.Orange], ['Alt-family', SaccharideColors.Pink], ['All-family', SaccharideColors.Purple], ['Tal-family', SaccharideColors.LightBlue], ['Ido-family', SaccharideColors.Brown], ['Fuc-family', SaccharideColors.Red], ['Generic/Unknown/Secondary', SaccharideColors.Secondary]];
var CommonSaccharideNames = {
  // Hexose
  Glc: ['GLC', 'BGC', 'Z8T', 'TRE', 'MLR' // tri-saccharide but homomer
  ],
  Man: ['MAN', 'BMA'],
  Gal: ['GLA', 'GAL', 'GZL', 'GXL', 'GIV'],
  Gul: ['4GL', 'GL0', 'GUP', 'Z8H'],
  Alt: ['Z6H', '3MK', 'SHD'],
  All: ['AFD', 'ALL', 'WOO', 'Z2D'],
  Tal: ['ZEE', 'A5C', 'SDY'],
  Ido: ['ZCD', 'Z0F', '4N2'],
  // HexNAc
  GlcNAc: ['NDG', 'NAG', 'NGZ'],
  ManNAc: ['BM3', 'BM7'],
  GalNAc: ['A2G', 'NGA', 'YYQ'],
  GulNAc: ['LXB'],
  AltNAc: [],
  AllNAc: ['NAA'],
  TalNAc: [],
  IdoNAc: ['LXZ', 'HSQ'],
  // Hexosamine
  GlcN: ['PA1', 'GCS'],
  ManN: ['95Z'],
  GalN: ['X6X', '1GN'],
  GulN: [],
  AltN: [],
  AllN: [],
  TalN: [],
  IdoN: [],
  // Hexuronate
  GlcA: ['GCU', 'BDP'],
  ManA: ['MAV', 'BEM'],
  GalA: ['ADA', 'GTR', 'GTK'],
  GulA: ['LGU'],
  AltA: [],
  AllA: [],
  TalA: ['X1X', 'X0X'],
  IdoA: ['IDR'],
  // Deoxyhexose
  Qui: ['G6D', 'YYK'],
  Rha: ['RAM', 'RM4', 'XXR'],
  '6dGul': ['66O'],
  '6dAlt': [],
  '6dTal': [],
  Fuc: ['FUC', 'FUL', 'FCA', 'FCB', 'GYE'],
  // DeoxyhexNAc
  QuiNAc: ['Z9W'],
  RhaNAc: [],
  '6dAltNAc': [],
  '6dTalNAc': [],
  FucNAc: ['49T'],
  // Di-deoxyhexose
  Oli: ['DDA', 'RAE', 'Z5J'],
  Tyv: ['TYV'],
  Abe: ['ABE'],
  Par: ['PZU'],
  Dig: ['Z3U'],
  Col: [],
  // Pentose
  Ara: ['64K', 'ARA', 'ARB', 'AHR', 'FUB', 'BXY', 'BXX', 'SEJ'],
  Lyx: ['LDY', 'Z4W'],
  Xyl: ['XYS', 'XYP', 'XYZ', 'HSY', 'LXC'],
  Rib: ['YYM', 'RIP', 'RIB', 'BDR', '0MK', 'Z6J', '32O'],
  // Deoxynonulosonate
  Kdn: ['KDM', 'KDN'],
  Neu5Ac: ['SIA', 'SLB'],
  Neu5Gc: ['NGC', 'NGE'],
  Neu: [],
  Sia: [],
  // Di-deoxynonulosonate
  Pse: [],
  Leg: [],
  Aci: [],
  '4eLeg': [],
  // Unknown
  Bac: [],
  LDmanHep: ['GMH'],
  Kdo: ['KDO'],
  Dha: [],
  DDmanHep: ['289'],
  MurNAc: ['MUB', 'AMU'],
  MurNGc: [],
  Mur: ['1S4', 'MUR'],
  // Assigned
  Api: ['XXM'],
  Fru: ['BDF', 'Z9N', 'FRU', 'LFR'],
  Tag: ['T6T'],
  Sor: ['SOE', 'UEA'],
  Psi: ['PSV', 'SF6', 'SF9', 'TTV']
};
var UnknownSaccharideNames = ['NGZ', 'LAT', 'PUF', 'GDA', '9WJ' // via updated CCD
];
export var SaccharideCompIdMap = function () {
  var map = new Map();

  for (var i = 0, il = Monosaccharides.length; i < il; ++i) {
    var saccharide = Monosaccharides[i];
    var names = CommonSaccharideNames[saccharide.abbr];

    if (names) {
      for (var j = 0, jl = names.length; j < jl; ++j) {
        map.set(names[j], saccharide);
      }
    }
  }

  for (var i = 0, il = UnknownSaccharideNames.length; i < il; ++i) {
    map.set(UnknownSaccharideNames[i], UnknownSaccharideComponent);
  }

  return map;
}();